module.exports = __webpack_public_path__ + "media/images/null-image-78b8bfc7.png";